import { projects } from "../../projects"
import ProjectCard from "./ProjectCard"
import './projectsgrid.css'

export default function ProjectsGrid() {
    return ( <div id="projects-grid">
    {projects.map((project, index) => { return <ProjectCard project={project} key={index}/>})}
    </div>)
}